import { render, staticRenderFns } from "./Impayes.vue?vue&type=template&id=096c8553"
import script from "./Impayes.vue?vue&type=script&lang=js"
export * from "./Impayes.vue?vue&type=script&lang=js"
import style0 from "./Impayes.vue?vue&type=style&index=0&id=096c8553&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports